const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSun = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.835938 5.164062 C 10.117188 4.445312 9.101562 3.980469 8 3.980469 C 6.898438 3.980469 5.882812 4.421875 5.164062 5.164062 C 4.445312 5.882812 3.980469 6.898438 3.980469 8 C 3.980469 9.101562 4.445312 10.117188 5.164062 10.835938 C 5.882812 11.554688 6.898438 12.019531 8 12.019531 C 9.101562 12.019531 10.117188 11.578125 10.835938 10.835938 C 11.554688 10.117188 12.019531 9.101562 12.019531 8 C 12.019531 6.898438 11.578125 5.882812 10.835938 5.164062 Z M 10.074219 10.074219 C 9.546875 10.601562 8.804688 10.921875 8 10.921875 C 7.195312 10.921875 6.453125 10.601562 5.925781 10.074219 C 5.398438 9.546875 5.078125 8.804688 5.078125 8 C 5.078125 7.195312 5.398438 6.453125 5.925781 5.925781 C 6.453125 5.398438 7.195312 5.078125 8 5.078125 C 8.804688 5.078125 9.546875 5.398438 10.074219 5.925781 C 10.601562 6.453125 10.921875 7.195312 10.921875 8 C 10.921875 8.804688 10.601562 9.546875 10.074219 10.074219 Z M 10.074219 10.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.449219 7.449219 L 13.820312 7.449219 C 13.523438 7.449219 13.269531 7.703125 13.269531 8 C 13.269531 8.296875 13.523438 8.550781 13.820312 8.550781 L 15.449219 8.550781 C 15.746094 8.550781 16 8.296875 16 8 C 16 7.703125 15.746094 7.449219 15.449219 7.449219 Z M 15.449219 7.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8 13.269531 C 7.703125 13.269531 7.449219 13.523438 7.449219 13.820312 L 7.449219 15.449219 C 7.449219 15.746094 7.703125 16 8 16 C 8.296875 16 8.550781 15.746094 8.550781 15.449219 L 8.550781 13.820312 C 8.550781 13.523438 8.296875 13.269531 8 13.269531 Z M 8 13.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.652344 12.890625 L 12.488281 11.726562 C 12.296875 11.511719 11.9375 11.511719 11.726562 11.726562 C 11.511719 11.9375 11.511719 12.273438 11.726562 12.488281 L 12.890625 13.652344 C 13.101562 13.863281 13.4375 13.863281 13.652344 13.652344 C 13.863281 13.4375 13.863281 13.101562 13.652344 12.890625 Z M 13.652344 12.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8 0 C 7.703125 0 7.449219 0.253906 7.449219 0.550781 L 7.449219 2.179688 C 7.449219 2.476562 7.703125 2.730469 8 2.730469 C 8.296875 2.730469 8.550781 2.476562 8.550781 2.179688 L 8.550781 0.550781 C 8.550781 0.253906 8.296875 0 8 0 Z M 8 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.671875 2.347656 C 13.460938 2.136719 13.121094 2.136719 12.910156 2.347656 L 11.746094 3.511719 C 11.535156 3.726562 11.535156 4.0625 11.746094 4.273438 C 11.9375 4.488281 12.296875 4.488281 12.507812 4.273438 L 13.671875 3.109375 C 13.882812 2.898438 13.882812 2.5625 13.671875 2.347656 Z M 13.671875 2.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.179688 7.449219 L 0.550781 7.449219 C 0.253906 7.449219 0 7.703125 0 8 C 0 8.296875 0.234375 8.550781 0.550781 8.550781 L 2.179688 8.550781 C 2.476562 8.550781 2.730469 8.296875 2.730469 8 C 2.730469 7.703125 2.476562 7.449219 2.179688 7.449219 Z M 2.179688 7.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.253906 11.726562 C 4.0625 11.511719 3.703125 11.511719 3.492188 11.726562 L 2.328125 12.890625 C 2.117188 13.101562 2.117188 13.4375 2.328125 13.652344 C 2.539062 13.863281 2.878906 13.863281 3.089844 13.652344 L 4.253906 12.488281 C 4.464844 12.273438 4.464844 11.9375 4.253906 11.726562 Z M 4.253906 11.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.253906 3.511719 L 3.089844 2.347656 C 2.878906 2.136719 2.539062 2.136719 2.328125 2.347656 C 2.117188 2.5625 2.117188 2.898438 2.328125 3.109375 L 3.492188 4.273438 C 3.703125 4.488281 4.042969 4.488281 4.253906 4.273438 C 4.464844 4.0625 4.464844 3.726562 4.253906 3.511719 Z M 4.253906 3.511719 "
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sun.be0d9985.svg";
export { ForwardRef as ReactComponent };